import { ComponentRoute } from '@/classes'

const OtherLabourRoutes = {
  OtherLabourListView: new ComponentRoute('/otherlabours', 'OtherLabourListView'),
  OtherLabourView: new ComponentRoute('/otherlabours/:itemOtherId', 'OtherLabourView'),
  OtherLabourDetail: new ComponentRoute('/otherlabours/:itemOtherId', 'OtherLabourDetail')
}

export default OtherLabourRoutes
